/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BankAccountIn,
  BankAccountsOut,
  ClearLinesIn,
  HTTPValidationError,
  ReconciliationOut,
  ReconciliationStartIn,
  ReconciliationsOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listBankAccountsResponse200 = {
  data: BankAccountsOut
  status: 200
}

export type listBankAccountsResponseSuccess = (listBankAccountsResponse200) & {
  headers: Headers;
};
;

export type listBankAccountsResponse = (listBankAccountsResponseSuccess)

export const getListBankAccountsUrl = () => {




  return `/api/banking/accounts`
}

/**
 * @summary List Bank Accounts
 */
export const listBankAccounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listBankAccountsResponse> => {

  return apiFetch<listBankAccountsResponse>(getListBankAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBankAccountsQueryKey = () => {
    return [
    `/api/banking/accounts`
    ] as const;
    }


export const getListBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBankAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBankAccounts>>> = ({ signal }) => listBankAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listBankAccounts>>>
export type ListBankAccountsQueryError = unknown


export function useListBankAccounts<TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof listBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBankAccounts<TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof listBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBankAccounts<TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Bank Accounts
 */

export function useListBankAccounts<TData = Awaited<ReturnType<typeof listBankAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBankAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createBankAccountResponse201 = {
  data: BankAccountsOut
  status: 201
}

export type createBankAccountResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createBankAccountResponseSuccess = (createBankAccountResponse201) & {
  headers: Headers;
};
export type createBankAccountResponseError = (createBankAccountResponse422) & {
  headers: Headers;
};

export type createBankAccountResponse = (createBankAccountResponseSuccess | createBankAccountResponseError)

export const getCreateBankAccountUrl = () => {




  return `/api/banking/accounts`
}

/**
 * @summary Create Bank Account
 */
export const createBankAccount = async (bankAccountIn: BankAccountIn, options?: Parameters<typeof apiFetch>[1]): Promise<createBankAccountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createBankAccountResponse>(getCreateBankAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bankAccountIn)
  }
);}





export const getCreateBankAccountMutationKey = () => ['createBankAccount'] as const;

export const getCreateBankAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,CreateBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,CreateBankAccountMutationVariables, TContext> => {

const mutationKey = getCreateBankAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBankAccount>>, CreateBankAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createBankAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createBankAccount>>>
    export type CreateBankAccountMutationBody = BankAccountIn
    export type CreateBankAccountMutationError = HTTPValidationError
    export type CreateBankAccountMutationVariables = {data: BankAccountIn}

    /**
 * @summary Create Bank Account
 */
export const useCreateBankAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBankAccount>>, TError,CreateBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBankAccount>>,
        TError,
        CreateBankAccountMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBankAccountMutationOptions(options), queryClient);
    }
    export type deleteBankAccountResponse204 = {
  data: void
  status: 204
}

export type deleteBankAccountResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteBankAccountResponseSuccess = (deleteBankAccountResponse204) & {
  headers: Headers;
};
export type deleteBankAccountResponseError = (deleteBankAccountResponse422) & {
  headers: Headers;
};

export type deleteBankAccountResponse = (deleteBankAccountResponseSuccess | deleteBankAccountResponseError)

export const getDeleteBankAccountUrl = (accountId: number,) => {




  return `/api/banking/accounts/${accountId}`
}

/**
 * @summary Delete Bank Account
 */
export const deleteBankAccount = async (accountId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteBankAccountResponse> => {

  return apiFetch<deleteBankAccountResponse>(getDeleteBankAccountUrl(accountId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteBankAccountMutationKey = () => ['deleteBankAccount'] as const;

export const getDeleteBankAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,DeleteBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,DeleteBankAccountMutationVariables, TContext> => {

const mutationKey = getDeleteBankAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBankAccount>>, DeleteBankAccountMutationVariables> = (props) => {
          const {accountId} = props ?? {};

          return  deleteBankAccount(accountId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBankAccount>>>

    export type DeleteBankAccountMutationError = HTTPValidationError
    export type DeleteBankAccountMutationVariables = {accountId: number}

    /**
 * @summary Delete Bank Account
 */
export const useDeleteBankAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,DeleteBankAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBankAccount>>,
        TError,
        DeleteBankAccountMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteBankAccountMutationOptions(options), queryClient);
    }
    export type listReconciliationsResponse200 = {
  data: ReconciliationsOut
  status: 200
}

export type listReconciliationsResponseSuccess = (listReconciliationsResponse200) & {
  headers: Headers;
};
;

export type listReconciliationsResponse = (listReconciliationsResponseSuccess)

export const getListReconciliationsUrl = () => {




  return `/api/banking/reconciliations`
}

/**
 * @summary List Reconciliations
 */
export const listReconciliations = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listReconciliationsResponse> => {

  return apiFetch<listReconciliationsResponse>(getListReconciliationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReconciliationsQueryKey = () => {
    return [
    `/api/banking/reconciliations`
    ] as const;
    }


export const getListReconciliationsQueryOptions = <TData = Awaited<ReturnType<typeof listReconciliations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReconciliations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReconciliationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReconciliations>>> = ({ signal }) => listReconciliations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReconciliations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReconciliationsQueryResult = NonNullable<Awaited<ReturnType<typeof listReconciliations>>>
export type ListReconciliationsQueryError = unknown


export function useListReconciliations<TData = Awaited<ReturnType<typeof listReconciliations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReconciliations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReconciliations>>,
          TError,
          Awaited<ReturnType<typeof listReconciliations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReconciliations<TData = Awaited<ReturnType<typeof listReconciliations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReconciliations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listReconciliations>>,
          TError,
          Awaited<ReturnType<typeof listReconciliations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReconciliations<TData = Awaited<ReturnType<typeof listReconciliations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReconciliations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Reconciliations
 */

export function useListReconciliations<TData = Awaited<ReturnType<typeof listReconciliations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listReconciliations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListReconciliationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type startReconciliationResponse201 = {
  data: ReconciliationOut
  status: 201
}

export type startReconciliationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type startReconciliationResponseSuccess = (startReconciliationResponse201) & {
  headers: Headers;
};
export type startReconciliationResponseError = (startReconciliationResponse422) & {
  headers: Headers;
};

export type startReconciliationResponse = (startReconciliationResponseSuccess | startReconciliationResponseError)

export const getStartReconciliationUrl = () => {




  return `/api/banking/reconciliations`
}

/**
 * @summary Start Reconciliation
 */
export const startReconciliation = async (reconciliationStartIn: ReconciliationStartIn, options?: Parameters<typeof apiFetch>[1]): Promise<startReconciliationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<startReconciliationResponse>(getStartReconciliationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reconciliationStartIn)
  }
);}





export const getStartReconciliationMutationKey = () => ['startReconciliation'] as const;

export const getStartReconciliationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startReconciliation>>, TError,StartReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startReconciliation>>, TError,StartReconciliationMutationVariables, TContext> => {

const mutationKey = getStartReconciliationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startReconciliation>>, StartReconciliationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startReconciliation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof startReconciliation>>>
    export type StartReconciliationMutationBody = ReconciliationStartIn
    export type StartReconciliationMutationError = HTTPValidationError
    export type StartReconciliationMutationVariables = {data: ReconciliationStartIn}

    /**
 * @summary Start Reconciliation
 */
export const useStartReconciliation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startReconciliation>>, TError,StartReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startReconciliation>>,
        TError,
        StartReconciliationMutationVariables,
        TContext
      > => {
      return useMutation(getStartReconciliationMutationOptions(options), queryClient);
    }
    export type getReconciliationResponse200 = {
  data: ReconciliationOut
  status: 200
}

export type getReconciliationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getReconciliationResponseSuccess = (getReconciliationResponse200) & {
  headers: Headers;
};
export type getReconciliationResponseError = (getReconciliationResponse422) & {
  headers: Headers;
};

export type getReconciliationResponse = (getReconciliationResponseSuccess | getReconciliationResponseError)

export const getGetReconciliationUrl = (reconciliationId: number,) => {




  return `/api/banking/reconciliations/${reconciliationId}`
}

/**
 * @summary Get Reconciliation
 */
export const getReconciliation = async (reconciliationId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getReconciliationResponse> => {

  return apiFetch<getReconciliationResponse>(getGetReconciliationUrl(reconciliationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReconciliationQueryKey = (reconciliationId: number,) => {
    return [
    `/api/banking/reconciliations/${reconciliationId}`
    ] as const;
    }


export const getGetReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getReconciliation>>, TError = HTTPValidationError>(reconciliationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReconciliationQueryKey(reconciliationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReconciliation>>> = ({ signal }) => getReconciliation(reconciliationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: reconciliationId !== null && reconciliationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getReconciliation>>>
export type GetReconciliationQueryError = HTTPValidationError


export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = HTTPValidationError>(
 reconciliationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReconciliation>>,
          TError,
          Awaited<ReturnType<typeof getReconciliation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = HTTPValidationError>(
 reconciliationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReconciliation>>,
          TError,
          Awaited<ReturnType<typeof getReconciliation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = HTTPValidationError>(
 reconciliationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Reconciliation
 */

export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = HTTPValidationError>(
 reconciliationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReconciliationQueryOptions(reconciliationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type discardReconciliationResponse204 = {
  data: void
  status: 204
}

export type discardReconciliationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type discardReconciliationResponseSuccess = (discardReconciliationResponse204) & {
  headers: Headers;
};
export type discardReconciliationResponseError = (discardReconciliationResponse422) & {
  headers: Headers;
};

export type discardReconciliationResponse = (discardReconciliationResponseSuccess | discardReconciliationResponseError)

export const getDiscardReconciliationUrl = (reconciliationId: number,) => {




  return `/api/banking/reconciliations/${reconciliationId}`
}

/**
 * @summary Discard Reconciliation
 */
export const discardReconciliation = async (reconciliationId: number, options?: Parameters<typeof apiFetch>[1]): Promise<discardReconciliationResponse> => {

  return apiFetch<discardReconciliationResponse>(getDiscardReconciliationUrl(reconciliationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDiscardReconciliationMutationKey = () => ['discardReconciliation'] as const;

export const getDiscardReconciliationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardReconciliation>>, TError,DiscardReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof discardReconciliation>>, TError,DiscardReconciliationMutationVariables, TContext> => {

const mutationKey = getDiscardReconciliationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discardReconciliation>>, DiscardReconciliationMutationVariables> = (props) => {
          const {reconciliationId} = props ?? {};

          return  discardReconciliation(reconciliationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscardReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof discardReconciliation>>>

    export type DiscardReconciliationMutationError = HTTPValidationError
    export type DiscardReconciliationMutationVariables = {reconciliationId: number}

    /**
 * @summary Discard Reconciliation
 */
export const useDiscardReconciliation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discardReconciliation>>, TError,DiscardReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discardReconciliation>>,
        TError,
        DiscardReconciliationMutationVariables,
        TContext
      > => {
      return useMutation(getDiscardReconciliationMutationOptions(options), queryClient);
    }
    export type setClearedLinesResponse200 = {
  data: ReconciliationOut
  status: 200
}

export type setClearedLinesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setClearedLinesResponseSuccess = (setClearedLinesResponse200) & {
  headers: Headers;
};
export type setClearedLinesResponseError = (setClearedLinesResponse422) & {
  headers: Headers;
};

export type setClearedLinesResponse = (setClearedLinesResponseSuccess | setClearedLinesResponseError)

export const getSetClearedLinesUrl = (reconciliationId: number,) => {




  return `/api/banking/reconciliations/${reconciliationId}/cleared`
}

/**
 * @summary Set Cleared Lines
 */
export const setClearedLines = async (reconciliationId: number,
    clearLinesIn: ClearLinesIn, options?: Parameters<typeof apiFetch>[1]): Promise<setClearedLinesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setClearedLinesResponse>(getSetClearedLinesUrl(reconciliationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(clearLinesIn)
  }
);}





export const getSetClearedLinesMutationKey = () => ['setClearedLines'] as const;

export const getSetClearedLinesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setClearedLines>>, TError,SetClearedLinesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setClearedLines>>, TError,SetClearedLinesMutationVariables, TContext> => {

const mutationKey = getSetClearedLinesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setClearedLines>>, SetClearedLinesMutationVariables> = (props) => {
          const {reconciliationId,data} = props ?? {};

          return  setClearedLines(reconciliationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetClearedLinesMutationResult = NonNullable<Awaited<ReturnType<typeof setClearedLines>>>
    export type SetClearedLinesMutationBody = ClearLinesIn
    export type SetClearedLinesMutationError = HTTPValidationError
    export type SetClearedLinesMutationVariables = {reconciliationId: number;data: ClearLinesIn}

    /**
 * @summary Set Cleared Lines
 */
export const useSetClearedLines = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setClearedLines>>, TError,SetClearedLinesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setClearedLines>>,
        TError,
        SetClearedLinesMutationVariables,
        TContext
      > => {
      return useMutation(getSetClearedLinesMutationOptions(options), queryClient);
    }
    export type finishReconciliationResponse200 = {
  data: ReconciliationOut
  status: 200
}

export type finishReconciliationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type finishReconciliationResponseSuccess = (finishReconciliationResponse200) & {
  headers: Headers;
};
export type finishReconciliationResponseError = (finishReconciliationResponse422) & {
  headers: Headers;
};

export type finishReconciliationResponse = (finishReconciliationResponseSuccess | finishReconciliationResponseError)

export const getFinishReconciliationUrl = (reconciliationId: number,) => {




  return `/api/banking/reconciliations/${reconciliationId}/finish`
}

/**
 * @summary Finish Reconciliation
 */
export const finishReconciliation = async (reconciliationId: number, options?: Parameters<typeof apiFetch>[1]): Promise<finishReconciliationResponse> => {

  return apiFetch<finishReconciliationResponse>(getFinishReconciliationUrl(reconciliationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFinishReconciliationMutationKey = () => ['finishReconciliation'] as const;

export const getFinishReconciliationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishReconciliation>>, TError,FinishReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finishReconciliation>>, TError,FinishReconciliationMutationVariables, TContext> => {

const mutationKey = getFinishReconciliationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishReconciliation>>, FinishReconciliationMutationVariables> = (props) => {
          const {reconciliationId} = props ?? {};

          return  finishReconciliation(reconciliationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinishReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof finishReconciliation>>>

    export type FinishReconciliationMutationError = HTTPValidationError
    export type FinishReconciliationMutationVariables = {reconciliationId: number}

    /**
 * @summary Finish Reconciliation
 */
export const useFinishReconciliation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishReconciliation>>, TError,FinishReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof finishReconciliation>>,
        TError,
        FinishReconciliationMutationVariables,
        TContext
      > => {
      return useMutation(getFinishReconciliationMutationOptions(options), queryClient);
    }
    export type reopenReconciliationResponse200 = {
  data: ReconciliationOut
  status: 200
}

export type reopenReconciliationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reopenReconciliationResponseSuccess = (reopenReconciliationResponse200) & {
  headers: Headers;
};
export type reopenReconciliationResponseError = (reopenReconciliationResponse422) & {
  headers: Headers;
};

export type reopenReconciliationResponse = (reopenReconciliationResponseSuccess | reopenReconciliationResponseError)

export const getReopenReconciliationUrl = (reconciliationId: number,) => {




  return `/api/banking/reconciliations/${reconciliationId}/reopen`
}

/**
 * @summary Reopen Reconciliation
 */
export const reopenReconciliation = async (reconciliationId: number, options?: Parameters<typeof apiFetch>[1]): Promise<reopenReconciliationResponse> => {

  return apiFetch<reopenReconciliationResponse>(getReopenReconciliationUrl(reconciliationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReopenReconciliationMutationKey = () => ['reopenReconciliation'] as const;

export const getReopenReconciliationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenReconciliation>>, TError,ReopenReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenReconciliation>>, TError,ReopenReconciliationMutationVariables, TContext> => {

const mutationKey = getReopenReconciliationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenReconciliation>>, ReopenReconciliationMutationVariables> = (props) => {
          const {reconciliationId} = props ?? {};

          return  reopenReconciliation(reconciliationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof reopenReconciliation>>>

    export type ReopenReconciliationMutationError = HTTPValidationError
    export type ReopenReconciliationMutationVariables = {reconciliationId: number}

    /**
 * @summary Reopen Reconciliation
 */
export const useReopenReconciliation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenReconciliation>>, TError,ReopenReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenReconciliation>>,
        TError,
        ReopenReconciliationMutationVariables,
        TContext
      > => {
      return useMutation(getReopenReconciliationMutationOptions(options), queryClient);
    }
